export const useGamingBonusActive = () => {
  const timer = useTimer();
  const gaming = useGamingStore();
  const expirationDates = computed<Date[]>(() => {
    if (!gaming.bonusDetails) return [];
    return gaming.bonusDetails.map((detail) => new Date(detail.expiresAt));
  });

  const currentDate = ref<Date>();
  currentDate.value = new Date();

  const currentTime = computed(() => {
    return currentDate.value.getTime() + timer.timeElapsed.value;
  });

  const durations = computed(() => {
    return expirationDates.value.map((expirationDate) => {
      const duration = (expirationDate.getTime() - currentTime.value) / 1000;

      return duration > 0 ? duration : 0;
    });
  });

  const activeBonus = computed(() => {
    if (activeBonusIndex.value === -1) return null;
    return gaming.bonusDetails[activeBonusIndex.value];
  });

  const activeBonusIndex = computed(() =>
    durations.value.findIndex((d) => d > 0)
  );

  const hasBonusActive = computed(() => activeBonusIndex.value > -1);

  const activeBonusTimeLeft = computed(() => {
    if (activeBonusIndex.value === -1) return 0;
    return durations.value[activeBonusIndex.value];
  });

  const activeBonusTimeLeftFormated = computed(() =>
    formatDurationMinAndSeconds(Math.abs(activeBonusTimeLeft.value))
  );

  const activeBonusValidityDuration = computed(() => {
    if (!activeBonus.value) return 0;
    return activeBonus.value.validityDurationInMinutes * 60;
  });

  const activeBonusProgress = computed(() => {
    if (!activeBonus.value) return 0;
    const current =
      activeBonusTimeLeft.value / activeBonusValidityDuration.value;
    return current;
  });

  watch(
    () => hasBonusActive.value,
    (active) => {
      if (active) {
        timer.reset();
        timer.start();
        currentDate.value = new Date();
      } else {
        timer.pause();
        timer.reset();
        currentDate.value = new Date();
      }
    }
  );

  return {
    durations,
    hasBonusActive,
    activeBonus,
    activeBonusIndex,
    activeBonusTimeLeft,
    activeBonusTimeLeftFormated,
    activeBonusProgress,
    activeBonusValidityDuration,
  };
};
